
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tineri/evenimente",
      function () {
        return require("private-next-pages/tineri/evenimente.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tineri/evenimente"])
      });
    }
  